export const colors = {
  background: '#9E9E9E',
  brightGreen: '#00A91C',
  white: '#FFFFFF',
  lightestGray: '#F0F0F0',
  lighterGray: '#F4F4F4',
  lightGray: '#E5E5E5',
  gray: '#C5C5C5',
  darkGray: '#A4A4A4',
  darkerGray: '#5E5E5E',
  darkBlue: '#1F2A34',
  blue: '#005ea2',
  lightBlue: '#F4F7FF',
  black: '#39444C',
  orange: '#C05600',
  primary: '#1b1b1b',
  secondary: '#4ADEC2',
  disabled: '#dfe1e2',
  success: {
    main: '#66bb6a',
    light: '#81c784',
    dark: '#388e3c',
  },
  warningLight: '#FAF3D1',
  warningDark: '#E5A000',
  uswds: {
    blue60: '#005ea2',
    grayCool60: '#565C65',
    blueWarm80: '#162e51',
    borderPrimaryLight: '#73b3e7',
    redCool70: '#9e394b',
    redCool50: '#d83933',
    redWarm05: '#f6efea',
    orange05: '#f6efe9',
    orange10: '#f2e4d4',
    violet: '#8168b3',
    basic: {
      red: '#e52207',
      orange: '#e66f0e',
      gold: '#ffbe2e',
      yellow: '#fee685',
      green: '#538200',
      mint: '#04c585',
      cyan: '#009ec1',
      blue: '#0076d6',
      indigo: '#676cc8',
      violet: '#8168b3',
      magenta: '#d72d79',
    },
    primary: {
      lighter: '#d9e8f6',
      light: '#73b3e7',
      main: '#005ea2',
      vivid: '#0050d8',
      dark: '#1a4480',
      darker: '#162e51',
    },
    base: {
      lightest: '#f0f0f0',
      lighter: '#dfe1e2',
      light: '#a9aeb1',
      main: '#71767a',
      dark: '#565c65',
      darker: '#3d4551',
      darkest: '#1b1b1b',
      ink: '#1b1b1b',
    },
    button: {
      disabled: '#c9c9c9',
      default: {
        default: '#005ea2',
        hover: '#1a4480',
        active: '#162e51',
      },
      gray: {
        default: '#757575',
        hover: '#5c5c5c',
        active: '#2e2e2e',
      },
    },
  },
};

export const layout = {
  borderRadius: {
    s: '2px',
    m: '4px',
    l: '6px',
  },
};

export const timing = {
  submitted: {
    beg: 200, // ms
    mid: 800,
    end: 200,
  },
};
